/* Syntex Fightwear — coming soon signup + policy dialogs.
 *
 * Shared verbatim between the static prototype (site/) and the Shopify theme
 * (shopify/theme/assets/). Keep them in sync; `tools/sync-theme.mjs` does it.
 *
 * Signups go to Klaviyo's client-side subscriptions endpoint rather than Shopify's
 * customer form, because the page promises recurring marketing texts and Klaviyo
 * records SMS marketing consent with the timestamp and consent language regulators
 * expect. Shopify's customer form is built around email and does not.
 *
 * The public API key is meant to be public — it is the Klaviyo Site ID, the /client/
 * endpoints are designed to be called from the browser, and it grants only
 * subscribe-type writes, never reads.
 */

(function () {
  "use strict";

  var ENDPOINT = "https://a.klaviyo.com/client/subscriptions";
  var REVISION = "2026-07-15";

  // Montréal brand, so an unprefixed 10-digit number is North American.
  var DEFAULT_COUNTRY_CODE = "1";

  /* ------------------------------------------------------------------ signup */

  var form = document.getElementById("signup");
  var message = document.getElementById("message");
  var button = form && form.querySelector("button[type=submit]");

  function show(text, kind) {
    message.textContent = text;
    message.className = "cs__message cs__message--" + kind;
    message.hidden = false;
  }

  // Deliberately permissive. Strict email regexes reject valid addresses, and the
  // real check is whether the confirmation lands in the inbox.
  function looksLikeEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  /* Klaviyo requires E.164 (+15145551234) and rejects anything else with a 400.
   * Returns "" for no input, null when the input cannot be made into a number. */
  function toE164(raw) {
    var trimmed = (raw || "").trim();
    if (!trimmed) return "";

    var hadPlus = trimmed.charAt(0) === "+";
    var digits = trimmed.replace(/\D/g, "");
    if (!digits) return null;

    if (hadPlus) return digits.length >= 8 ? "+" + digits : null;
    if (digits.length === 10) return "+" + DEFAULT_COUNTRY_CODE + digits;
    if (digits.length === 11 && digits.charAt(0) === "1") return "+" + digits;
    return null;
  }

  function splitName(full) {
    var parts = full.trim().split(/\s+/);
    return {
      first: parts[0] || "",
      last: parts.length > 1 ? parts.slice(1).join(" ") : "",
    };
  }

  function buildPayload(listId, name, email, phone) {
    var subscriptions = { email: { marketing: { consent: "SUBSCRIBED" } } };
    // Only claim SMS consent when a number was actually given — the consent copy
    // on the page is specifically about the phone number.
    if (phone) subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } };

    var attributes = {
      email: email,
      first_name: name.first,
      last_name: name.last,
      subscriptions: subscriptions,
    };
    if (phone) attributes.phone_number = phone;

    return {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Coming soon page",
          profile: { data: { type: "profile", attributes: attributes } },
        },
        relationships: { list: { data: { type: "list", id: listId } } },
      },
    };
  }

  if (form && message && button) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var publicKey = form.getAttribute("data-klaviyo-key");
      var listId = form.getAttribute("data-klaviyo-list");

      var nameRaw = form.elements.name.value.trim();
      var emailRaw = form.elements.email.value.trim();

      if (!nameRaw) {
        show("Please enter your name.", "error");
        form.elements.name.focus();
        return;
      }

      if (!looksLikeEmail(emailRaw)) {
        show("Please enter a valid email address.", "error");
        form.elements.email.focus();
        return;
      }

      var phone = toE164(form.elements.phone.value);
      if (phone === null) {
        show("That phone number doesn't look right. Leave it blank if you'd rather not.", "error");
        form.elements.phone.focus();
        return;
      }

      if (!publicKey || !listId) {
        if (window.console) console.error("Klaviyo key or list id missing on the form.");
        show("Signup isn't available right now. Please try again later.", "error");
        return;
      }

      button.disabled = true;
      var originalLabel = button.textContent;
      button.textContent = "Sending…";

      fetch(ENDPOINT + "?company_id=" + encodeURIComponent(publicKey), {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.api+json",
          revision: REVISION,
        },
        body: JSON.stringify(
          buildPayload(listId, splitName(nameRaw), emailRaw, phone)
        ),
      })
        .then(function (response) {
          // Klaviyo answers 202 Accepted with an empty body on success.
          if (response.status === 202) {
            show(
              "You're on the list. We'll be in touch when the first drop lands.",
              "success"
            );
            form.hidden = true;
            return;
          }
          return response.text().then(function (body) {
            throw new Error("Klaviyo " + response.status + ": " + body);
          });
        })
        .catch(function (error) {
          if (window.console) console.error(error);
          show("Something went wrong on our end. Please try again in a moment.", "error");
          button.disabled = false;
          button.textContent = originalLabel;
        });
    });
  }

  /* ---------------------------------------------------------- policy dialogs */

  /* The policy text is rendered inline rather than linked: while the store is
   * password protected, Shopify redirects /policies/* back to /password, so a link
   * would loop. Triggers only exist for policies that actually have content. */

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-policy]");
    if (trigger) {
      var dialog = document.getElementById("policy-" + trigger.dataset.policy);
      if (dialog && typeof dialog.showModal === "function") {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest("[data-close]")) {
      var open = event.target.closest("dialog");
      if (open) open.close();
      return;
    }

    // Click outside the panel closes it. A <dialog> fills the viewport for hit
    // testing, so compare against its content box rather than trusting the target.
    var dlg = event.target.closest("dialog");
    if (dlg && dlg.open) {
      var box = dlg.getBoundingClientRect();
      var outside =
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom;
      if (outside) dlg.close();
    }
  });
})();
